export const ENABLE_SHIPPING_ADDRESS_MODAL = 'ENABLE_SHIPPING_ADDRESS_MODAL';
export const DISABLE_SHIPPING_ADDRESS_MODAL = 'DISABLE_SHIPPING_ADDRESS_MODAL';
export const ENABLE_CREDIT_CARD_INFO_MODAL = 'ENABLE_CREDIT_CARD_INFO_MODAL';
export const DISABLE_CREDIT_CARD_INFO_MODAL = 'DISABLE_CREDIT_CARD_INFO_MODAL';
export const ENABLE_CREDIT_CARD_LIST = 'ENABLE_CREDIT_CARD_LIST';
export const DISABLE_CREDIT_CARD_LIST = 'DISABLE_CREDIT_CARD_LIST';



// WEBPACK FOOTER //
// ./src/actions/modals/types.js